import React from 'react';
import { LuEllipsisVertical, LuBuilding2, LuUser, LuMapPin, LuNavigation } from 'react-icons/lu';
import { direccionSede, linkMaps } from '../../utils/clienteUtils';
import { M } from '../servicio/ServicioUI';
import { SEMAFORO } from '../mapa/vistasMapa';

// Fila de la lista de Clientes (13-oct-2026), mismo armado que Trabajos:
// Cliente · Último service (semáforo del Mapa) · Qué hacer · ⋯
// En celu, tarjeta compacta de 2 líneas + botón.
// 2-nov-2026: "Pendiente" y "Próximo paso" eran dos columnas casi siempre vacías: queda una, "Qué hacer", con el
// botón solo cuando hay algo (Cobrar $X, Ofrecer service), y filas de un renglón en compu.
export const GRID_CLIENTES = 'md:grid-cols-[minmax(0,2fr)_minmax(0,1fr)_minmax(0,1.1fr)_36px]';
const color = (id) => SEMAFORO.find(s => s.id === id)?.color || '#9CA3AF';
const ACCION = { cobrar: 'Cobrar', ofrecer: 'Ofrecer service' };
const pesos = (n) => `$${Math.round(Number(n) || 0).toLocaleString('es-AR')}`;

// Lo que coincide con la búsqueda es una sede (28-oct-2026): se ve cuál, con Google Maps a un toque, y
// tocarla abre el cliente en esa sede.
function SedesCoinciden({ sedes, onAbrirSede }) {
    if (!sedes?.length) return null;
    return (
        <div className="mt-2 space-y-1.5 md:col-span-full">
            {sedes.slice(0, 4).map(s => {
                const dir = direccionSede(s);
                return (
                    <div key={s.id} className="flex items-center gap-2 pl-2.5 pr-1 py-1 rounded-xl bg-panel">
                        <button type="button" onClick={(ev) => { ev.stopPropagation(); onAbrirSede(s); }} className="flex-1 min-w-0 text-left active:opacity-70">
                            <span className="flex items-center gap-1.5 text-body font-black text-ink truncate">
                                <LuMapPin size={14} className="shrink-0 text-brand-red" />{[s.codigo, s.nombreSede].filter(Boolean).join(' · ')}
                            </span>
                            {dir && <span className="block pl-5 text-caption text-muted truncate">{dir}</span>}
                        </button>
                        {dir && (
                            <a href={linkMaps(dir)} target="_blank" rel="noreferrer" onClick={ev => ev.stopPropagation()}
                                className="shrink-0 h-10 px-3 rounded-lg bg-brand-red text-white text-label font-black inline-flex items-center gap-1.5 active:scale-95">
                                <LuNavigation size={14} /> Ir
                            </a>
                        )}
                    </div>
                );
            })}
            {sedes.length > 4 && <p className="px-1 text-caption text-muted">y {sedes.length - 4} lugar{sedes.length - 4 !== 1 ? 'es' : ''} más</p>}
        </div>
    );
}

export default function ClienteRow({ cliente, e, onAbrir, onAccion, onMenu, sedesMatch = [], onAbrirSede }) {
    const Tipo = e.esEmpresa ? LuBuilding2 : LuUser;
    const detalle = [e.zona, e.sedesN > 1 ? `${e.sedesN} sedes` : null,
        e.equiposN ? `${e.equiposN} equipo${e.equiposN !== 1 ? 's' : ''}` : null].filter(Boolean).join(' · ');
    const service = (
        <span className="flex items-center gap-1.5 min-w-0">
            <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ background: color(e.sem) }} />
            <span className={`truncate ${e.sem === 'rojo' ? 'font-bold text-[color:var(--alerta-tx)]' : 'text-secondary'}`}>
                {e.ultimo ? e.hace : 'Sin service'}
            </span>
        </span>
    );
    const pendiente = e.deuda > 0
        ? <span className="font-black text-[color:var(--alerta-tx)]">Debe <M valor={e.deuda} /></span>
        : e.abiertos > 0 ? <span className="text-secondary">{e.abiertos === 1 ? 'Trabajo abierto' : `${e.abiertos} trabajos abiertos`}</span>
            : <span className="text-muted">—</span>;
    const boton = e.accion && (
        <button type="button" onClick={(ev) => { ev.stopPropagation(); onAccion(e.accion); }}
            className={`h-9 px-3.5 rounded-xl text-label font-black active:scale-95 shrink-0 ${e.accion === 'cobrar' ? 'bg-[color:var(--etapa-cobrar)] text-[#1C1917]' : 'bg-[#25D366] text-white'}`}>
            {e.accion === 'cobrar' ? `Cobrar ${pesos(e.deuda)}` : ACCION[e.accion]}
        </button>
    );
    const queHacer = boton || (e.abiertos > 0 ? <span className="text-caption text-secondary">{e.abiertos === 1 ? 'Trabajo abierto' : `${e.abiertos} trabajos abiertos`}</span> : null);
    const menu = (
        <button type="button" onClick={(ev) => { ev.stopPropagation(); onMenu(); }} aria-label="Más acciones"
            className="w-9 h-9 rounded-xl flex items-center justify-center text-muted hover:bg-chip shrink-0">
            <LuEllipsisVertical size={18} />
        </button>
    );
    const marco = 'rounded-2xl bg-card border border-black/10 dark:border-white/[0.08] cursor-pointer';
    const tarifa = cliente.tieneTarifa && (
        <span className="shrink-0 px-1.5 py-0.5 rounded-md bg-[color:var(--etapa-cobrar-bg)] text-[color:var(--etapa-cobrar-tx)] text-label font-black">Tarifa mensual</span>
    );

    return (
        <>
            {/* Celular */}
            <div onClick={onAbrir} className={`md:hidden ${marco} px-3 py-2.5`}>
                <div className="flex items-center gap-2">
                    <span className="flex-1 min-w-0">
                        <span className="flex items-center gap-1.5 min-w-0">
                            <Tipo size={13} className="text-muted shrink-0" />
                            <span className="font-bold text-body text-ink truncate">{cliente.nombre}</span>
                            {tarifa}
                        </span>
                        <span className="block text-caption text-muted truncate mt-0.5">{detalle || (e.esEmpresa ? 'Empresa' : 'Particular')}</span>
                    </span>
                    {menu}
                </div>
                <div className="flex items-center justify-between gap-2 mt-1.5 text-caption">
                    <span className="flex items-center gap-2 min-w-0">{service}{!boton && e.abiertos > 0 && <span className="truncate">· {pendiente}</span>}</span>
                    {boton}
                </div>
                <SedesCoinciden sedes={sedesMatch} onAbrirSede={onAbrirSede} />
            </div>

            {/* Escritorio */}
            <div onClick={onAbrir} className={`hidden md:grid ${marco} ${GRID_CLIENTES} gap-4 items-center px-4 py-1.5 min-h-[52px] hover:bg-panel transition-colors`}>
                <span className="flex items-center gap-2 min-w-0">
                    <Tipo size={14} className="text-muted shrink-0" />
                    <span className="font-bold text-body text-ink truncate shrink">{cliente.nombre}</span>{tarifa}
                    <span className="text-caption text-muted truncate">{detalle || (e.esEmpresa ? 'Empresa' : 'Particular')}</span>
                </span>
                <span className="text-caption min-w-0">{service}</span>
                <span className="flex justify-end min-w-0">{queHacer}</span>
                {menu}
                <SedesCoinciden sedes={sedesMatch} onAbrirSede={onAbrirSede} />
            </div>
        </>
    );
}
